import {
  Box,
  chakra,
  keyframes,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import Header from '../../../../../components/Header/Header';
import { IoDocuments } from 'react-icons/io5';
import CreateResourceMobilePage from '../create';
import ListSolicitationResource from './listSolicitation';
import { IResourceItem } from './cardDetail';
import { useSearchParams } from 'react-router-dom';
import useNavigateBackButton from './teste';
import CardHeaderMobile from '../../../../../components/Mobile/header';
import MessageForUser from '../../../../../components/pages/SelectiveProcess/MessageForUser';
import { useEffect, useState } from 'react';

const floatIn = keyframes`
      from { opacity: 0; transform: translateY(18px) scale(0.995); }  
  `;

const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

export interface IGenericResources {
  isOpen?: boolean;
  selectiveProcess?: string;
  identification?: string;
  period?: string;
  listItem?: IResourceItem[];
  instruction_to_candidates?: string;
}

interface IOwnProps {
  isLoading: boolean;
  dataToResource?: IGenericResources;
  isImpugnation?: boolean;
  id: string;
  isUpdateOrDelete?: boolean;
}

const ResourceDetailMobilePage: React.FC<IOwnProps> = ({
  isLoading,
  dataToResource,
  isImpugnation = false,
  id,
  isUpdateOrDelete,
}) => {
  const [params] = useSearchParams();
  const selectiveProcessId = params.get('selective_process') || '';
  const isOpenModal = params.get('om');
  const bgGradient = useColorModeValue('linear(to-br, gray.50, white)', 'linear(to-br, gray.900, gray.800)');
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  const [resourceId, setResourceId] = useState<string>();

  useNavigateBackButton(`/painel/recursos?selective_process=${selectiveProcessId}`);

  const { isOpen, onClose, onOpen } = useDisclosure({ defaultIsOpen: !!isOpenModal });

  const openUpdateResource = (id: string) => {
    setResourceId(id);
    if (!isOpen) {
      setResourceId(id);
      onOpen();
    }
  };

  useEffect(() => {
    if (!isOpen) setResourceId(undefined);
  }, [isOpen]);

  return (
    <>
      <Stack height={`${dataToResource?.isOpen ? 'calc(100% - 40px)' : '100%'}`} top={0} w="100%" bg="white" gap={0}>
        <Header />

        <VStack mt={0} flex={1} overflowY="auto" py={2}>
          {(isLoading && (
            <VStack flex={1} w="100%" justify="center">
              <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
              <Text fontSize="sm">
                Buscando {isImpugnation ? 'impugnações solicitadas' : 'recursos solicitados'}...
              </Text>
            </VStack>
          )) || (
            <AnimatedBox
              bgGradient={bgGradient}
              borderRadius="lg"
              boxShadow="lg"
              mx={3}
              p={{ base: 5, md: 10 }}
              borderWidth={'1px'}
              borderColor={borderColor}
              bg="white"
              flex={1}
              display="flex"
            >
              <VStack boxSizing="border-box" maxW="lg" spacing={4} align="stretch">
                <CardHeaderMobile
                  title={isImpugnation ? 'Impugnações' : 'Recursos'}
                  subTitle="Se você já possui alguma solicitação aberta, ela será exibida na lista abaixo junto com o respectivo status. Para visualizar mais informações, clique em <b>Mostrar detalhes</b>."
                  badgeText="Detalhes"
                  badgeIcon={<IoDocuments size={12} />}
                  colorScheme="blue"
                />
                {dataToResource?.instruction_to_candidates &&
                  dataToResource?.instruction_to_candidates !== '<p><br></p>' && (
                    <MessageForUser showIcon={false} informationText={dataToResource.instruction_to_candidates} />
                  )}
                <VStack spacing={3} align="stretch" h="100%">
                  <Text
                    bgColor="primaryColor"
                    color="white"
                    boxSizing="border-box"
                    py={1}
                    px={5}
                    fontWeight="bold"
                    fontSize="sm"
                    h="fit-content"
                    textTransform="uppercase"
                  >
                    {dataToResource?.selectiveProcess}
                  </Text>
                  <VStack spacing={0} mt={1} mx={2} align="start">
                    <Text fontSize="sm" color="gray.900" fontWeight="semibold">
                      {dataToResource?.identification}
                    </Text>
                    <Text fontSize="x-small" color="gray.900" fontWeight="semibold">
                      {dataToResource?.period}
                    </Text>
                  </VStack>
                  <VStack spacing={2} flex={1}>
                    <ListSolicitationResource
                      onOpenUpdateResource={openUpdateResource}
                      isImpugnation={isImpugnation}
                      data={dataToResource?.listItem}
                      isUpdateOrDelete={isUpdateOrDelete}
                    />
                  </VStack>
                </VStack>
              </VStack>
            </AnimatedBox>
          )}
        </VStack>
        {dataToResource?.isOpen && (
          <CreateResourceMobilePage
            selectiveProcess={dataToResource.selectiveProcess}
            {...{ isOpen, onClose, onOpen, id, resourceId, isImpugnation }}
          />
        )}
      </Stack>
    </>
  );
};

export default ResourceDetailMobilePage;
